module.exports = __webpack_public_path__ + "img/forum-coffeekitchen.6ddaa768.svg";